import PageOptions from "@/config/PageOptions.vue";
import {
  resolveProductKey,
  resolveSisterProductUrl,
} from "@/utils/productIdentity.js";

const PRODUCT_ASSETS = {
  opt: {
    icon: "/assets/img/solo_icono.png",
    letters: "/assets/img/letras_logo.png",
    heroImage: "/assets/img/solo_logo.png",
  },
  mixora: {
    icon: "/assets/img/logo.png",
    letters: null,
    heroImage: "/assets/img/logo.png",
  },
};

const FEATURE_ICONS = {
  opt: {
    light: [
      "fa-crosshairs",
      "fa-tint",
      "fa-check-circle",
      "fa-thermometer-half",
    ],
    dark: ["fa-shield-alt", "fa-link", "fa-leaf", "fa-bolt"],
  },
  mixora: ["fa-fill-drip", "fa-palette", "fa-sliders-h"],
};

export default {
  name: "LandingPage",
  data() {
    const productKey = resolveProductKey();

    return {
      productKey,
      sisterKey: productKey === "opt" ? "mixora" : "opt",
      sisterProductUrl: resolveSisterProductUrl(),
      productAssets: PRODUCT_ASSETS,
      featureIcons: FEATURE_ICONS,
    };
  },
  computed: {
    isOptProduct() {
      return this.productKey === "opt";
    },
    primaryAssets() {
      return this.productAssets[this.productKey];
    },
    secondaryAssets() {
      return this.productAssets[this.sisterKey];
    },
    primaryProductName() {
      return this.$t(`landing.products.${this.productKey}.shortName`);
    },
    secondaryProductName() {
      return this.$t(`landing.products.${this.sisterKey}.shortName`);
    },
    primaryFeatures() {
      const icons = this.isOptProduct
        ? this.featureIcons.opt.light
        : this.featureIcons.mixora;
      const count = this.isOptProduct ? 4 : 3;

      return Array.from({ length: count }, (_, index) => {
        const featureIndex = index + 1;
        return {
          icon: icons[index],
          title: this.$t(
            `landing.products.${this.productKey}.feature${featureIndex}Title`
          ),
          text: this.$t(
            `landing.products.${this.productKey}.feature${featureIndex}Text`
          ),
        };
      });
    },
    primaryFeaturesDark() {
      if (!this.isOptProduct) return [];

      return [5, 6, 7, 8].map((featureIndex, index) => ({
        icon: this.featureIcons.opt.dark[index],
        title: this.$t(
          `landing.products.${this.productKey}.feature${featureIndex}Title`
        ),
        text: this.$t(
          `landing.products.${this.productKey}.feature${featureIndex}Text`
        ),
      }));
    },
    comparisonRows() {
      return [this.productKey, this.sisterKey].map((key) => ({
        key,
        isPrimary: key === this.productKey,
        name: this.$t(`landing.products.${key}.shortName`),
        inkLine: this.$t(`landing.products.${key}.inkLine`),
      }));
    },
    hasSisterLink() {
      return Boolean(this.sisterProductUrl);
    },
    brandLine() {
      return this.$t(`landing.products.${this.productKey}.brandLine`);
    },
  },
  created() {
    PageOptions.pageEmpty = true;
  },
  beforeRouteLeave(to, from, next) {
    PageOptions.pageEmpty = false;
    next();
  },
  mounted() {
    if (
      process.env.VUE_APP_ENVIRONMENT === "PRODUCTION" &&
      location.protocol !== "https:"
    ) {
      location.replace(
        `https:${location.href.substring(location.protocol.length)}`
      );
      return;
    }

    const persona = JSON.parse(localStorage.getItem("persona"));
    const token = localStorage.getItem("token");
    if (persona && token) {
      this.$router.replace("/app");
    }
  },
};
